import { formatDistanceToNow as formatDistance } from 'date-fns';

/**
 * Parse a date string from the backend as UTC.
 * FastAPI/SQLAlchemy returns naive ISO strings (e.g. "2024-03-29T10:00:00")
 * without a 'Z' suffix. Without the fix, browsers interpret them as LOCAL time,
 * causing timestamps to appear N hours ago (equal to the user's UTC offset).
 */
export const parseUTCDate = (date: string | Date): Date => {
  if (date instanceof Date) return date;
  // Append 'Z' if no timezone info present so the string is treated as UTC
  if (!date.endsWith('Z') && !date.includes('+') && !/[+-]\d{2}:\d{2}$/.test(date)) {
    return new Date(date + 'Z');
  }
  return new Date(date);
};

export const formatTimeAgo = (date: string | Date): string => {
  try {
    return formatDistance(parseUTCDate(date), { addSuffix: true });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Unknown time';
  }
};

export const formatDate = (date: string | Date): string => {
  try {
    return parseUTCDate(date).toLocaleDateString();
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid date';
  }
};
